<template>
  <div class="input-group" :class="{'has-validation': errorMessage}" v-if="valueModel">
    <div class="form-floating" :class="{'is-invalid': errorMessage}">
      <textarea
        v-if="props.type == 'multiline'"
        v-upper-case="props.upperCase"
        :id="'inputText-' + $.uid"
        class="form-control"
        :class="[{'is-invalid': errorMessage, 'text-uppercase': props.upperCase, 'text-capitalize': props.capitalize}, props.inputClass]"
        :placeholder="props.placeholder"
        v-model="valueModel.value"
        :required="props.required"
        :rows="props.rows"
        :style="props.inputStyle + ';height: ' + (60 + 20 * props.rows) + 'px'"
        @change="emit('change')"
        @blur="onBlur"
      ></textarea>
      <input
        v-else
        v-upper-case="props.upperCase"
        :type="props.type"
        :id="'inputText-' + $.uid"
        class="form-control"
        :class="[{'is-invalid': errorMessage, 'text-uppercase': props.upperCase, 'text-capitalize': props.capitalize}, props.inputClass]"
        :style="props.inputStyle"
        :placeholder="props.placeholder"
        v-model="valueModel.value"
        :required="props.required"
        :inputmode="props.type === 'email' ? 'email' : (props.type === 'url' ? 'url' : 'text')"
        :disabled="props.disabled"
        :autocomplete="props.autocomplete"
        :name="props.name"
        @change="emit('change')"
        @blur="onBlur"
      />
      <label :for="'inputText-' + $.uid" style="width: 100%">
        {{props.label}} <span v-if="props.subLabel" class="fst-italic">( {{ props.subLabel }} )</span> {{ props.required ? '*' : '' }}
      </label>
      <div class="invalid-feedback">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed } from 'vue';

const model = defineModel<string | null>({required: false});
const emit = defineEmits(['change'])

const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  label: string;
  subLabel?: string;
  placeholder?: string;
  required?: boolean;
  type?: 'text' | 'email' | 'url' | 'multiline' | 'password';
  rows?: number
  inputClass?: string
  disabled?: boolean
  autocomplete?: string
  name?: string
  upperCase?: boolean,
  capitalize?: boolean,
  validateOnValueUpdate?: boolean,
  validateOnBlur?: boolean,
  inputStyle?: string,
}>(), {
  placeholder: '',
  required: false,
  type: 'text',
  rows: 2,
  inputClass: '',
  disabled: false,
  upperCase: false,
  capitalize: false,
  validateOnValueUpdate: true,
  validateOnBlur: false
});

const { value, errorMessage, handleBlur } = props.valueKey !== undefined
  ? useField<string>(() => props.valueKey!, undefined, {
      validateOnValueUpdate: props.validateOnValueUpdate,
    })
  : { value: undefined, errorMessage: undefined, handleBlur: undefined };

const onBlur = (event: FocusEvent) => {
  if (props.validateOnBlur) {
    handleBlur?.(event, true);
  }
};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})

</script>
